<template>
  <ppt-slide-viewer module-code="rt_jm" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "RtJm",
  components: { PptSlideViewer }
};
</script>
